import React, { ReactElement } from "react";
import style from "./style.module.scss";

export default function VerticalOfferSkeleton(): ReactElement {
    return (
        <div
            className={`${style.container}  relative  mb-[30px] px-4 py-4 border rounded-5`}
            style={{
                borderColor: "#e3e3e3",
            }}
        >
            <div className="flex flex-col flex-wrap items-center">
                <div className="flex flex-col gap-2">
                    <div className="skeleton skeleton-text !w-[150px] !h-[80px] !mb-8" />
                </div>
                <div className="skeleton skeleton-text" />
                <div className="skeleton skeleton-text" />
                <div className="flex items-start gap-2 justify-between">
                    <div className="flex flex-col !w-[200px] !mt-4">
                        <div className="skeleton skeleton-button" />
                    </div>
                </div>
            </div>
        </div>
    );
}
